import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, Row, Col, Label, Card, CardBody, Input } from "reactstrap";
import { toast } from "react-toastify";
import DataTable from "../../components/common/DataTable";
import ConfirmModal from "../../components/common/ConfirmModal";
import PageHeader from "../../components/common/PageHeader";
import { getSaloonsRequest , getSaloonInfo } from "../../redux/saloons/actions";
import { api, FRONT_BASE_URL , isActionPermitted, socket, SOCKET , LOCAL_STORAGE_USER , ENABLE_STATUS_TEXT, STATUS } from "../../util";
import { getAccountsRequest } from "../../redux/accounts/actions";
import { getLocationsRequest } from "../../redux/locations/actions";

const ListSaloons = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { saloons, count, loading } = useSelector((state) => state.saloons);
  const { permissions , accountId} = useSelector((state) => state.user);
  const { accounts } = useSelector((state) => state.accounts);
  const { locations } = useSelector((state) => state.locations);

  const [showPairModal, setShowPairModal] = useState(false);
  const [pairSaloonId, setpairSaloonId] = useState(null);
  const [pairingEvent, setpairingEvent] = useState(null);
  const [showDeviceCodeModal, setShowDeviceCodeModal] = useState(false);
  const [deviceCode, setDeviceCode] = useState(null);
  const [devicePairSuccess, setDevicePairSuccess] = useState(false);
  const [devicePairFail, setDevicePairFail] = useState(false);
  const [saloonId , setSaloonId] = useState(null);
  const [currentStatus , setCurrentStatus] = useState(null);
  const [currentManualBookingStatus , setCurrentManualBookingStatus] = useState(null);
  const [showStatusModal, setshowStatusModal] = useState(false);
  const [showManualBookingStatusModal, setShowManualBookingStatusModal] = useState(false);
  //console.log("dddd" , Intl.DateTimeFormat().resolvedOptions().timeZone );
  
  const [paginationConfig, setPaginationConfig] = useState({
    page: 1,
    limit: 10,
    filter: {
      name: "",
      account: "",
      location: "",
    },
    // sort: "-id",
    // search: "",
  });

  useEffect(() => {
    if (isActionPermitted("services", "read", permissions)) {
      dispatch(getSaloonsRequest(paginationConfig));
      dispatch(getAccountsRequest());
      dispatch(getLocationsRequest());
    }
  }, [paginationConfig, permissions]);

  useEffect(() => {
    if (!socket) return;
    socket.on(SOCKET.LISTEN_DEVICE_PAIRED_CHANGE, (data) => {
      if (data && data.squareDeviceId && data.squareId) {
        setDevicePairSuccess(true);
        setShowDeviceCodeModal(false);
        setpairSaloonId(null);
      } else {
        setDevicePairFail(true);
        setShowDeviceCodeModal(false);
        dispatch(getSaloonsRequest(paginationConfig));
      }
    });
  }, []);

  const pairDevice = async (id) => {
    try {
      const response = await api.post("/square/createDeviceCode/" + id);
      if (response.status === 200) {
        if (isActionPermitted("services", "read", permissions)) {
          dispatch(getSaloonsRequest(paginationConfig));
        }
        // toast.success(response?.data?.data.message || response.message);
        if (response?.data?.data?.deviceCode) {
          // Paired event
          setDeviceCode(response?.data?.data?.deviceCode.code);
          setShowDeviceCodeModal(true);
        }
      }
    } catch (error) {
      toast.error(error.response?.data?.message || error.message);
    }
  };

  const copyUrl = (locationId) => {
	const encodedLocationId = btoa(locationId);
	console.log("encodedLocationId" , encodedLocationId );
    navigator.clipboard.writeText(FRONT_BASE_URL + "/book-appointment/" + encodedLocationId);
    toast.success("Link Copied Successfully");
  }

  const onSearchChange = ({ target }) => {
    const { value } = target;
    const pc = paginationConfig;
    pc.filter.name = value;
    setPaginationConfig({ ...pc,  page: 1, limit: 10 });
  };
  const getUserInfo = JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER));
  console.log("getUserInfo" , getUserInfo.accountId );
  var showAddSaloonButton = true;
  if(getUserInfo.accountId){
	  showAddSaloonButton = false;
  }
  const changeSaloonStatus = async (saloonId) => {
	    // var currentEnableDisableStatus = !e.target.checked;
	    const statusInfo = {
	      id: saloonId,
	      status: currentStatus
	    }
	    try {
	      const response = await api.post('/saloons/updateRecordStatus' , statusInfo);

	      if(response.status === 200) {
	        if (isActionPermitted("saloon", "read", permissions)) {
	          dispatch(getSaloonsRequest(paginationConfig));
	        }
	        toast.success(response?.data?.message || response.message);
	      }
	    } catch (error) {
	      toast.error(error.response?.data?.message || error.message);
	    }
	  }
  const changeSaloonManualBookingStatus = async (saloonId) => {
	    // var currentEnableDisableStatus = !e.target.checked;
	    const statusInfo = {
	      id: saloonId,
	      status: currentManualBookingStatus
	    }
	    try {
	      const response = await api.post('/saloons/updateManualBookingRecordStatus' , statusInfo);

	      if(response.status === 200) {
	        if (isActionPermitted("saloon", "read", permissions)) {
	          dispatch(getSaloonsRequest(paginationConfig));
	        }
	        toast.success(response?.data?.message || response.message);
	      }
	    } catch (error) {
	      toast.error(error.response?.data?.message || error.message);
	    }
	  }
	  const siteBaseUrl = FRONT_BASE_URL + '/login/';
  return (
    <React.Fragment>
    { isActionPermitted("saloon", "edit", permissions) && (
    	<PageHeader
        title="Salons"
        addBtnUrl="/salons/add"
        shouldShowAddBtn={showAddSaloonButton}
      /> ) }
      <Card>
        <CardBody>
          <Row className="gy-3 gx-3">
            <Col xl={3} md={3} sm={12} xs={12}>
              <Label>Salon</Label>
              <Input
                value={paginationConfig.filter.name}
                type="search"
                placeholder="Search Salon"
                role="search"
                aria-roledescription="search for salon"
                autoFocus
                onChange={onSearchChange}
              />
            </Col>
            {accountId == 0 && (
              <Col xl={3} md={3} sm={12} xs={12}>
                <Label>Square Account</Label>
                <Input caret type="select" name="" value={paginationConfig.filter.account}
                  onChange={(e) => {
                    let x = paginationConfig;
                    x.filter.account = e.target.value;
                    setPaginationConfig({ ...x,  page: 1, limit: 10 });
                  }}
                  >
                  <option value={""}>All Square Account</option>
                  {accounts.map((_, index) => (
                    <option key={_.id} value={_.id}>
                      {_.name}
                    </option>
                  ))}
                </Input>
              </Col>
            )}
            <Col xl={3} md={3} sm={12} xs={12}>
              <Label>Location</Label>
              <Input caret type="select" name="location" value={paginationConfig.filter.location}
                onChange={(e) => {
                  let x = paginationConfig;
                  x.filter.location = e.target.value;
                  setPaginationConfig({ ...x,  page: 1, limit: 10 });
                }}
                >
                <option value={""}>All Location</option>
                {locations.map((_, index) => (
                  <option key={_.id} value={_.squareLocationId}>
                    {_.name}
                  </option>
                ))}
              </Input>
            </Col>
          </Row>
        </CardBody>
      </Card>
      <DataTable
        isPagination
        count={count}
        loading={loading}
        paginationConfig={paginationConfig}
        setPaginationConfig={setPaginationConfig}
        data={saloons}
        initialState={ !(isActionPermitted("saloon", "edit", permissions) && (!getUserInfo.accountId)) ? {hiddenColumns : ['actions']} : {} }
        columns={[
          { Header: "Name", accessor: "Saloon.name" },
          { Header: "Location", accessor: "Saloon.location" },
          {
            Header: "Tax",
            accessor: "Saloon.tax",
            Cell: ({ row }) => {
              return !!row.original.Saloon.tax
                ? row.original.Saloon.tax + "%"
                : "-";
            },
          },
          {
            Header: "Email",
            accessor: "User.email",
            Cell: ({ row }) => {
              //return ( ( row?.original?.Admin?.email ? row.original.Admin.email + '\r\n' : '' )  +  ( row?.original?.User?.email ? row.original.User.email : '' )  ) ;
			  return (
            		  (row?.original?.Admin?.email ? 
            		      ( 
            				  <div>
            				  	<a href={siteBaseUrl + row.original.User.loginToken }>{row.original.Admin.email}</a>
            				  	<br/>
            				  	{ row?.original?.User?.email && ( 
            				  		  <a href={siteBaseUrl + row.original.User.loginToken }  >
            				  		  	{row.original.User.email}
            	                      </a> 
            	               )}
            				  </div>
            		      ) : ''
            		  ) 	
          		);
            },
          },
          {
            Header: "Device",
            accessor: "Saloon.device",
            Cell: ({ row }) => {
              return !!row.original.Saloon.device ? (
                <div className="d-flex gap-2 w-75 justify-content-between align-items-center">
                  <p className="mb-0">PAIRED&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</p> 
                  <Button
                    color="danger"
                    onClick={() => {
                      setpairSaloonId(row.original.Saloon.id);
                      setShowPairModal(true);
                      setpairingEvent("unpair");
                    }}
                  >
                    <i className="bi bi-pencil-square"></i>
                  </Button>
                  { row?.original?.Saloon?.locationId && ( 
                		  <button color="info" className="btn btn-primary" onClick={() => copyUrl(row.original.Saloon.id)} >
                        <i className="bi bi-copy"></i>
                      </button> 
                  )}
                </div>
              ) : (
                <div className="d-flex gap-2 w-75 justify-content-between align-items-center">
                  <p className="mb-0">UNPAIRED</p>
                  <Button
                    onClick={() => {
                      setpairSaloonId(row.original.Saloon.id);
                      setShowPairModal(true);
                      setpairingEvent("pair");
                    }}
                  >
                    <i className="bi bi-pencil-square"></i>
                  </Button>
                  { row?.original?.Saloon?.locationId && ( 
                		  <button color="info" className="btn btn-primary" onClick={() => copyUrl(row.original.Saloon.id)} >
                        <i className="bi bi-copy"></i>
                      </button>
                  )}
                </div>
              );
            },
          },
          
          {
              Header: "Actions",
              accessor: "actions",
              width: "10%",
              Cell: ({ row }) => {
                return (
                  <div className="d-flex gap-2">
                      <Button onClick={() => navigate(`/salons/${row.original.saloonId}`)} >
                        <i className="bi bi-pencil-square"></i>
                      </Button>
                      <div className="d-flex gap-2">
	  	                {isActionPermitted("saloon", "edit", permissions) && (
	  	                  <div className="form-check form-switch">
	  	                    <input type="checkbox" className="form-check-input" disabled={!!row.original.Saloon.device ? 'disabled' : '' } checked={row.original?.Saloon?.is_active === STATUS.ACTIVE ? true : false}
	  	                      onChange={() => {
	  	                    	  setSaloonId(row.original?.saloonId);
	  	                          setCurrentStatus(row.original?.Saloon?.is_active === STATUS.ACTIVE ? STATUS.ACTIVE_TEXT : STATUS.INACTIVE_TEXT);
	  	                          setshowStatusModal(true);
	  	                      }} />
	  	                    <label className="form-check-label" htmlFor={"customSwitches-"+row.original?.saloonId}>{row.original?.Saloon?.is_active === STATUS.ACTIVE ? STATUS.ACTIVE_TEXT : STATUS.INACTIVE_TEXT }</label>
	  	                  </div>
	  	                )}
	  	              </div>
		  	            <div className="d-flex gap-2">
	  	                {isActionPermitted("saloon", "edit", permissions) && (
	  	                  <div className="form-check form-switch">
	  	                    <input type="checkbox" className="form-check-input" checked={row.original?.Saloon?.is_manual_booking === STATUS.ACTIVE ? true : false}
	  	                      onChange={() => {
	  	                    	  setSaloonId(row.original?.saloonId);
	  	                    	  setCurrentManualBookingStatus(row.original?.Saloon?.is_manual_booking === STATUS.ACTIVE ? STATUS.ACTIVE_TEXT : STATUS.INACTIVE_TEXT);
	  	                    	  setShowManualBookingStatusModal(true);
	  	                      }} />
	  	                    <label className="form-check-label" htmlFor={"customSwitches-manual-booking-"+row.original?.saloonId}>{row.original?.Saloon?.is_manual_booking === STATUS.ACTIVE ? STATUS.ACTIVE_TEXT : STATUS.INACTIVE_TEXT }</label>
	  	                  </div>
	  	                )}
	  	              </div>
                    {/*
                    {isActionPermitted("saloon", "delete", permissions) && (
                      <Button
                        color="danger"
                        onClick={() => {
                          setDeleteId(row.original.id);
                          setShowDeleteModal(true);
                        }}
                      >
                        <i className="bi bi-trash"></i>
                      </Button>
                    )}
                    */ }
                  </div>
                );
              },
            },
        ]}
      />

      {showPairModal && (
        <ConfirmModal
          type={pairingEvent == "pair" ? "confirm" : "delete"}
          title={pairingEvent == "pair" ? "Pair device" : "Unpair device"}
          message={
            pairingEvent == "pair"
              ? "Are you sure you want to pair this device?"
              : "Are you sure you want to unpair this device?"
          }
          isOpen={showPairModal}
          setIsOpen={setShowPairModal}
          onOk={() => pairDevice(pairSaloonId)}
          onCancel={() => {
            setpairSaloonId(null);
            setShowPairModal(false);
          }}
        />
      )}

      {showDeviceCodeModal && (
        <Modal isOpen={showDeviceCodeModal} centered>
          <ModalHeader>Device Code Generated!</ModalHeader>
          <ModalBody>
            <div>
              Please Enter This Code To Your Square Terminal Device and Wait
              Until It Is Paired:
            </div>
            <div className="d-flex justify-content-center">
              <h3>{deviceCode}</h3>
            </div>
          </ModalBody>
        </Modal>
      )}

      {devicePairSuccess && (
        <Modal
          isOpen={devicePairSuccess}
          centered
          toggle={() => setDevicePairSuccess(false)}
        >
          <ModalHeader>Success!</ModalHeader>
          <ModalBody>Your Device Is Paired Sucessfully.</ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={() => setDevicePairSuccess(false)}>
              Okay
            </Button>
          </ModalFooter>
        </Modal>
      )}

      {devicePairFail && (
        <Modal
          isOpen={devicePairFail}
          centered
          toggle={() => setDevicePairFail(false)}
        >
          <ModalHeader>Failed!</ModalHeader>
          <ModalBody>Your Device Is Not Paired.</ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={() => setDevicePairFail(false)}>
              Okay
            </Button>
          </ModalFooter>
        </Modal>
      )}
      {showStatusModal && (
    	        <ConfirmModal
    	          isOpen={showStatusModal}
    	          setIsOpen={setshowStatusModal}
    	          onOk={() => changeSaloonStatus(saloonId)}
    	          onCancel={() => {
    	            setSaloonId(null);
    	            setCurrentStatus(null);
    	            setshowStatusModal(false);
    	          }}
    	          type="update"
    	          title="Update Status"
    	        />
    	      )}
      {showManualBookingStatusModal && (
  	        <ConfirmModal
  	          isOpen={showManualBookingStatusModal}
  	          setIsOpen={setShowManualBookingStatusModal}
  	          onOk={() => changeSaloonManualBookingStatus(saloonId)}
  	          onCancel={() => {
  	            setSaloonId(null);
  	            setCurrentManualBookingStatus(null);
  	            setShowManualBookingStatusModal(false);
  	          }}
  	          type="update"
  	          title="Update Manual BookingStatus"
  	        />
  	      )}
    </React.Fragment>
  );
};

export default ListSaloons;
